import { faXmark, faAsterisk } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { ReactNode, useEffect, useRef, useState } from "react";
import { Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";

interface Props {
    controlId: string;
    value?: string;
    label: ReactNode | string;
    onChange?: (value: string) => void;
    mandatory?: boolean;
    error?: string;
    placeholder?: string;
}

function ProfileEditNode({
    controlId,
    value,
    label,
    onChange,
    mandatory = false,
    error,
    placeholder,
}: Props) {
    const { t } = useTranslation("common");
    const inputRef = useRef<HTMLInputElement>(null);

    // Track the display value
    const [displayValue, setDisplayValue] = useState(value ?? "");

    // Determine if the field is invalid
    const isInvalid = !!error || (mandatory && (!displayValue || displayValue.trim() === ""));

    // Compute the error message to display
    const errorMessage = error || (mandatory && (!displayValue || displayValue.trim() === "") ? '' : undefined);

    // Update display value when controlled value changes externally
    useEffect(() => {
        if (value !== undefined) {
            setDisplayValue(value);
        }
    }, [value]);

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const newVal = e.target.value;
        onChange?.(newVal);
        setDisplayValue(newVal);
    };

    // Use the controlled value
    const currentValue = value ?? "";

    return (
        <Form.Group controlId={controlId} className="form-group-custom position-relative">
            <Form.Label className="dataNode-label">
                {label}
                {mandatory && label && (<span className="ms-1 text-danger"><FontAwesomeIcon icon={faAsterisk} /></span>)}
            </Form.Label>
            <Form.Control
                ref={inputRef}
                className="form-control-input-custom visual-selection-aid"
                type="text"
                value={currentValue}
                onChange={handleInputChange}
                isInvalid={isInvalid}
                placeholder={placeholder}
                data-lpignore="true"
                data-1p-ignore="true"
                autoComplete="off"
            />
            <Form.Control.Feedback type="invalid">
                {errorMessage}
            </Form.Control.Feedback>
        </Form.Group>
    );
}

export default ProfileEditNode;